



































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {
    HAS_PRIVILEGES_OVER_CONTACTS,
    HAS_PRIVILEGES_OVER_CUSTOMERS,
    HAS_PRIVILEGES_OVER_DIRECTORY_GROUPS,
    HAS_PRIVILEGES_OVER_EQUIPMENTS,
    HAS_PRIVILEGES_OVER_FEEDBACKS,
    HAS_PRIVILEGES_OVER_FINANCES,
    HAS_PRIVILEGES_OVER_HEALTH_REPORTS,
    HAS_PRIVILEGES_OVER_PDT,
    HAS_PRIVILEGES_OVER_REPORTS,
    HAS_PRIVILEGES_OVER_TICKETS,
    IS_EMPLOYEE,
} from '@/modules/users/store/user.getters';
import { layout, user, loader } from '@/modules/shared/shared/store/namespaces';
import { LOG_OUT } from '@/modules/users/store/user.actions';
import { MenuItem } from '../domain/menu-item';
import ModalProfile from '@/components/users/ModalProfile.vue';
import DaycoRoleManagement from '@/components/users/DaycoRoleManagement.vue';
import Footer from '@/modules/shared/layouts/components/Footer.vue';
import MainNav from '@/modules/shared/layouts/components/MainNav.vue';
import { EventBus } from '@/main';
import LayoutFooter from '@/modules/shared/layouts/components/Footer.vue';
import LogoutModal from '@/modules/shared/layouts/components/LogoutModal.vue';
import { CAV_CUSTOMER } from '@/modules/customers/domain/customer';
import { Watch } from 'vue-property-decorator';
import { Actions, Resources } from '@/modules/shared/shared/domain/constants/constants';

@Component({
    name: 'layout',
    components: { LogoutModal, LayoutFooter, DaycoRoleManagement, ModalProfile, Footer, MainNav },
})
export default class Layout extends Vue {
    drawer: boolean | null = null;
    selection = null;
    loaded = false;
    mini: boolean = false;
    showContent: boolean = true;
    snackbarError: boolean = false;
    snackbarSuccess: boolean = false;
    timeout: number = 5000;

    $refs!: {
        logoutModal: any;
    };

    @layout.State('title')
    title;

    @layout.State('route')
    route;

    @user.State('role')
    role;

    @user.State('contact')
    contact;

    @user.Getter(HAS_PRIVILEGES_OVER_TICKETS)
    HAS_PRIVILEGES_OVER_TICKETS;

    @user.Getter(HAS_PRIVILEGES_OVER_CONTACTS)
    HAS_PRIVILEGES_OVER_CONTACTS;

    @user.Getter(HAS_PRIVILEGES_OVER_CUSTOMERS)
    HAS_PRIVILEGES_OVER_CUSTOMERS;

    @user.Getter(HAS_PRIVILEGES_OVER_DIRECTORY_GROUPS)
    HAS_PRIVILEGES_OVER_DIRECTORY_GROUPS;

    @user.Getter(HAS_PRIVILEGES_OVER_EQUIPMENTS)
    HAS_PRIVILEGES_OVER_EQUIPMENTS;

    @user.Getter(HAS_PRIVILEGES_OVER_FEEDBACKS)
    HAS_PRIVILEGES_OVER_FEEDBACKS;

    @user.Getter(HAS_PRIVILEGES_OVER_FINANCES)
    HAS_PRIVILEGES_OVER_FINANCES;

    @user.Getter(HAS_PRIVILEGES_OVER_HEALTH_REPORTS)
    HAS_PRIVILEGES_OVER_HEALTH_REPORTS;

    @user.Getter(HAS_PRIVILEGES_OVER_PDT)
    HAS_PRIVILEGES_OVER_PDT;

    @user.Getter(HAS_PRIVILEGES_OVER_REPORTS)
    HAS_PRIVILEGES_OVER_REPORTS;

    @user.Getter(IS_EMPLOYEE)
    IS_EMPLOYEE;

    @user.Action(LOG_OUT)
    LOG_OUT;

    mounted() {
        this.loaded = true;
        EventBus.$on('refreshView', () => this.refreshView());
    }

    created() {
        this.loaded = false;
    }

    get menuItems(): MenuItem[] {
        return [
            // TICKETS ////////////////////////////////////////////////////////
            {
                icon: 'mdi-ticket-confirmation-outline',
                appendIcon: 'mdi-chevron-down',
                text: 'Tickets',
                model: false,
                show: true,
                children: [
                    {
                        icon: 'mdi-finance',
                        text: 'Histórico / Crear Ticket',
                        link: '/portal/tickets',
                        show: !this.IS_EMPLOYEE,
                    },
                    {
                        icon: 'mdi-account-tie',
                        text: 'Accesos al DC',
                        link: '/portal/access-permissions',
                        show:
                            !this.IS_EMPLOYEE || (this.HAS_PRIVILEGES_OVER_PDT && this.IS_EMPLOYEE),
                    },
                    {
                        icon: 'mdi-record-circle',
                        text: 'Gestión de Cintas',
                        link: '/portal/tape-management',
                        show: true,
                    },
                    {
                        icon: 'mdi-history',
                        text: 'Histórico',
                        link: '/portal/dayco-tickets',
                        show: this.IS_EMPLOYEE && this.HAS_PRIVILEGES_OVER_TICKETS,
                    },
                ],
            },
            // REPORTES ///////////////////////////////////////////////////////
            {
                icon: 'mdi-file-document-outline',
                text: 'Reportes',
                show: !this.IS_EMPLOYEE || (this.IS_EMPLOYEE && this.HAS_PRIVILEGES_OVER_REPORTS),
                children: [
                    {
                        icon: 'mdi-finance',
                        text: 'Disponibilidad DC',
                        link: '/portal/reports',
                        show: true,
                    },
                    {
                        icon: 'mdi-history',
                        text: 'Gestión',
                        show:
                            this.IS_EMPLOYEE &&
                            (this.$can(
                                // @ts-ignore
                                Actions.CREATE.name,
                                Resources.PRIVILEGE_REPORT_MANAGEMENT.name,
                            ) ||
                                this.$can(
                                    // @ts-ignore
                                    Actions.READ.name,
                                    Resources.PRIVILEGE_REPORT_MANAGEMENT.name,
                                )),
                        children: [
                            {
                                icon: 'mdi-table-large',
                                text: 'Registro',
                                show: this.$can(
                                    // @ts-ignore
                                    Actions.CREATE.name,
                                    Resources.PRIVILEGE_REPORT_MANAGEMENT.name,
                                ),
                                children: [
                                    {
                                        icon: 'mdi-file-table-outline',
                                        text: 'Mantenimiento DC',
                                        link: '/portal/dayco-report-registry',
                                        show: true,
                                    },
                                    {
                                        icon: 'mdi-clipboard-plus-outline',
                                        text: 'Salud y Gestión',
                                        link: '/portal/dayco-health-report-registry',
                                        show: true,
                                    },
                                    {
                                        icon: 'mdi-table-check',
                                        text: 'Disponibilidad',
                                        link: '/portal/availability-registry',
                                        show: true,
                                    },
                                    {
                                        icon: 'mdi-table-cancel',
                                        text: 'Incidencia',
                                        link: '/portal/incident-registry',
                                        show: true,
                                    },
                                ],
                            },
                            {
                                icon: 'mdi-timetable',
                                text: 'Histórico',
                                children: [
                                    {
                                        icon: 'mdi-file-table-outline',
                                        text: 'Reportes',
                                        link: '/portal/dayco-reports-history',
                                        show: true,
                                    },
                                    {
                                        icon: 'mdi-alert-outline',
                                        text: 'Interrupciones',
                                        link: '/portal/dayco-incidents-history',
                                        show: true,
                                    },
                                ],
                                show: true,
                            },
                        ],
                    },
                    {
                        icon: 'mdi-file-table-box-multiple-outline',
                        text: 'Informes',
                        show: true,
                        children: [
                            {
                                icon: 'mdi-file-table-outline',
                                text: 'Mantenimiento DC',
                                link: '/portal/informs',
                                show: true,
                            },
                            {
                                icon: 'mdi-clipboard-plus-outline',
                                text: 'Salud y Gestión',
                                link: this.IS_EMPLOYEE
                                    ? '/portal/customer-health-informs'
                                    : '/portal/health-informs',
                                show:
                                    this.IS_EMPLOYEE ||
                                    this.contact.customer.customerType === CAV_CUSTOMER,
                            },
                        ],
                    },
                ],
            },
            // GENERAL ////////////////////////////////////////////////////////
            {
                icon: 'mdi-receipt',
                text: 'Facturación',
                link: '/portal/finances',
                show: false, // this.HAS_PRIVILEGES_OVER_FINANCES && !this.IS_EMPLOYEE,
            },
            {
                click: this.openDialogOnClick,
                icon: 'mdi-account-group-outline',
                text: 'Roles',
                link: this.openDialogOnClick,
                show: this.HAS_PRIVILEGES_OVER_DIRECTORY_GROUPS && this.IS_EMPLOYEE,
            },
            {
                icon: 'mdi-account-cash-outline',
                text: 'Clientes',
                link: '/portal/dayco-customers',
                show: this.HAS_PRIVILEGES_OVER_CUSTOMERS && this.IS_EMPLOYEE,
            },
            {
                icon: 'mdi-server',
                text: 'Equipos',
                link: '/portal/dayco-equipments',
                show: this.HAS_PRIVILEGES_OVER_EQUIPMENTS && this.IS_EMPLOYEE,
            },
            {
                icon: 'mdi-account-box-outline',
                text: 'Contactos',
                link: '/portal/contacts',
                show: true,
            },
            {
                icon: 'mdi-information-outline',
                text: 'Mis guías y tutoriales',
                show: true,
                cssClass: 'remove-letter-spacing',
                children: [
                    {
                        icon: 'mdi-handshake-outline',
                        text: 'Acuerdos de servicio',
                        link: '/portal/infodayco/service-model',
                        show: true,
                    },
                    {
                        icon: 'mdi-clipboard-play-multiple-outline',
                        text: 'Tutoriales',
                        link: '/portal/infodayco/tutorials',
                        show: true,
                    },
                    {
                        icon: 'mdi-file-upload-outline',
                        text: 'Gestión',
                        link: '/portal/infodayco/management',
                        //@ts-ignore
                        show: this.$can(Actions.UPDATE.name, Resources.PRIVILEGE_INFODAYCO.name),
                    },
                ],
            },
            {
                icon: 'mdi-account-heart-outline',
                text: 'Feedbacks',
                link: '/portal/feedbacks',
                show: this.HAS_PRIVILEGES_OVER_FEEDBACKS && this.IS_EMPLOYEE,
            },
            {
                icon: 'mdi-power',
                text: 'Cerrar sesión',
                cssClass: 'mt-2 logout-button',
                link: this.logout,
                show: true,
            },
        ];
    }

    get showFooter() {
        if (this.loaded) {
            //@ts-ignore
            return this.$refs.navigationDrawer.isMouseover;
        }
        return false;
    }

    async logout() {
        this.$refs.logoutModal.openModal();
    }

    openProfileModal() {
        //@ts-ignore
        this.$refs.profileModal.open();
    }

    get loadingDaycoRoles() {
        return this.$store.state.loadingDaycoRoles;
    }

    get getNameColsSize() {
        let size = this.contact.customer.name.length;

        if (size >= 40) {
            return 4;
        } else if (size >= 30) {
            return 5;
        } else if (size >= 20) {
            return 6;
        } else {
            return 7;
        }
    }

    openDialogOnClick() {
        this.reRenderDaycoRoles();
        this.dialog = true;
    }

    dialog: boolean = false;
    daycoRolesKey: number = 0;

    reRenderDaycoRoles() {
        if (this.daycoRolesKey !== 0) {
            this.daycoRolesKey = 0;
        } else {
            this.daycoRolesKey = 1;
        }
    }

    closeDialog(snackbar, snackbarText, snackbarColor) {
        this.dialog = false;
    }

    get isSmallScreen() {
        return this.$vuetify.breakpoint.smAndDown;
    }

    userModified() {
        this.snackbarSuccess = true;
    }

    refreshView() {
        this.showContent = false;
        this.$nextTick(() => {
            this.showContent = true;
        });
    }

    @Watch('$vuetify.breakpoint.smAndDown')
    onBreakpointChanged(value: boolean) {
        this.drawer = !value;
    }
}
